var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 16.3333C5.16658 16.3333 3.59714 15.6979 2.29158 14.4271C0.98603 13.1563 0.333252 11.6042 0.333252 9.77083C0.333252 8.85417 0.506863 8.00347 0.854085 7.21875C1.20131 6.43403 1.68047 5.73611 2.29158 5.125L6.99992 0.5L11.7083 5.125C12.3194 5.73611 12.7985 6.43403 13.1458 7.21875C13.493 8.00347 13.6666 8.85417 13.6666 9.77083C13.6666 11.5903 13.0173 13.1389 11.7187 14.4167C10.4201 15.6944 8.84714 16.3333 6.99992 16.3333Z",
    fill: "white",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.3b4b2fe51530cd67eb9e0899932b11db.svg";
export { ForwardRef as ReactComponent };